import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { getFormQuestionAttributeDisplayAs, setQuestionAttributeDisplayAs } from "reduxSlices/formBuilderSlice"
import { Select } from "shared/selects"

export const DROPDOWN = "dropdown"
export const RADIO = "radio"

const options = [
  { label: "Dropdown", value: DROPDOWN },
  { label: "Radio Buttons", value: RADIO },
]

const DisplayAs = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionDisplayAs = useSelector(getFormQuestionAttributeDisplayAs({ sectionIndex, questionIndex }))

  const updateDisplayAs = (newDisplayAs) => dispatch(setQuestionAttributeDisplayAs({
    sectionIndex, questionIndex, newDisplayAs,
  }))

  return (
    <div className="flex-center mb-4">
      <div className="font-medium">Display</div>
      <Select
        className="text-sm"
        style={{ height: "32px" }}
        value={questionDisplayAs}
        options={options}
        onChange={updateDisplayAs}
        label="select question display type"
      />
    </div>
  )
}

DisplayAs.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DisplayAs
